import { render, staticRenderFns } from "./RequiredFieldsWarningComponent.vue?vue&type=template&id=447d3f98"
import script from "./RequiredFieldsWarningComponent.vue?vue&type=script&lang=js"
export * from "./RequiredFieldsWarningComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports